import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Select from "react-select";

const RemoveUser = () => {
  const location = useLocation();
  const users = location.state?.userData?.users || [];

  const [selectedUser, setSelectedUser] = useState(null);

  // Prepare options for the Select dropdown
  const userOptions = users.map((user) => ({
    value: user.mail,
    label: user.mail,
    role: user.role?.length > 0 ? user.role[0].label : "No Role",
  }));

  // Handle remove (empty function as requested)
  const handleRemove = () => {
    console.log("Remove logic goes here for:", selectedUser);
  };

  return (
    <div className="flex flex-col max-w-md mx-auto mt-10 p-6 border border-gray-300 rounded-md shadow-sm">
      <h2 className="text-2xl font-semibold mb-6">Remove User</h2>

      {/* Email Dropdown */}
      <Select
        options={userOptions}
        value={selectedUser}
        onChange={setSelectedUser}
        placeholder="Select an email"
        className="mb-4"
      />

      {/* Disabled Role Input */}
      <input
        type="text"
        value={selectedUser?.role || ""}
        disabled
        className="w-full px-4 py-2 border border-gray-300 rounded-md bg-gray-100 text-gray-700 mb-6"
        placeholder="User role will appear here"
      />

      {/* Remove Button */}
      <button
        type="button"
        onClick={handleRemove}
        disabled={!selectedUser}
        className={`px-6 py-2 text-white rounded-md transition-colors duration-200 ${
          selectedUser
            ? "bg-red-600 hover:bg-red-700"
            : "bg-gray-400 cursor-not-allowed"
        }`}
      >
        Remove User
      </button>
    </div>
  );
};

export default RemoveUser;
